import { useContext, type FunctionComponent } from 'react';
import { SUPPORT_FAQ_LINK } from '../../../../constants/links';
import { AddToCartContext } from '../../../../contexts/add-to-cart/add-to-cart.context';
import { VariantContext } from '../../../../contexts/variant/variant.context';
import { TrackedEventCase } from '../../../../helpers/analytics/event-types';
import { buildGTMCompleteSaveClick } from '../../../../helpers/analytics/gtm/event-builders';
import { isConfigurationValid } from '../../../../helpers/product-helper/configuration/product-configuration.helper';
import { useTrackEvent } from '../../../../hooks/analytics/analytics.hooks';
import { useAddProductToProjects } from '../../../../hooks/save-to-project/add-product-to-projects.hooks';
import { type ProjectInputWithName } from '../../../../types/project.types';
import { StyledLink } from '../../../common-components/link/styled-link.component';
import { CompareButton } from '../../compare-button/compare-button.component';
import { SaveToProjectButton } from '../../save-to-project-button/save-to-project-button.component';

export const ExtraControlsWidget: FunctionComponent = () => {
	const { selectedVariant } = useContext(VariantContext);
	const { selection } = useContext(AddToCartContext);
	const track = useTrackEvent();
	const { saveProductToProject } = useAddProductToProjects();
	const configurationValid = selection ? isConfigurationValid(selection) : Boolean(selection);

	const onSaveToProject = async (projectInput: ProjectInputWithName[]) => {
		track(buildGTMCompleteSaveClick('pdp-save-to-project-drawer'));
		await saveProductToProject(projectInput, selection, selectedVariant.id);
	};

	const trackOpenDrawer = () => {
		track(buildGTMCompleteSaveClick('pdp-save-to-project-drawer', TrackedEventCase.OPEN_SAVE_TO_PROJECT));
	};
	const trackNewProjectClick = () => {
		track(buildGTMCompleteSaveClick('pdp-save-to-project-drawer', TrackedEventCase.CLICK_NEW_PROJECT));
	};

	return (
		<div className="flex justify-between mt3">
			<div className="flex flex-wrap w-100-l justify-between">
				<div className="flex">
					<div className="relative">
						<SaveToProjectButton
							size="SMALL"
							onSaveToProject={onSaveToProject}
							quantities={[selection?.quantity || 1]}
							disabled={!configurationValid}
							showQuantityInput={true}
							trackOpenDrawer={trackOpenDrawer}
							trackNewProjectClick={trackNewProjectClick}
						/>
					</div>
					<div className="ml2">
						<CompareButton variantId={selectedVariant.id} hasBorder={true} size={'SMALL'} automationHook="compare" />
					</div>
				</div>
				<StyledLink
					url={SUPPORT_FAQ_LINK}
					className={'dib mt2 pl1 tr'}
					automationHook="return-shipping-details"
					analyticsHook="return-shipping-details">
					Return & Shipping Details
				</StyledLink>
			</div>
		</div>
	);
};
